import $ from '~/qwery';
import bean from '~/bean';

export default class Button {
    constructor(el) {
        if ($(el).data('button'))
            return $(el).data('button');
        $(el).data('button', this);
        this.$el = $(el);
        this.disabled(this.$el.hasClass('disabled'));
        if ( ! this.disabled())
            this.$el.attr('tabindex', 0);
        bean.on(this.$el[0], 'click', e => {
            this.$el[0].dispatchEvent(new CustomEvent('press', {
                bubbles: true,
                detail: {
                    type: 'mouse',
                    initialEvent: e,
                }
            }));
        });
        bean.on(this.$el[0], 'keydown', e => {
            switch (e.key) {
            case ' ':
            case 'Enter':
                if (this._shouldFirePress(e.key)) {
                    if (e.key == ' ')
                        e.preventDefault();
                    this.$el[0].dispatchEvent(new CustomEvent('press', {
                        bubbles: true,
                        detail: {
                            type: 'keyboard',
                            initialEvent: e,
                        }
                    }));
                }
                break;
            }
        });
    }

    _shouldFirePress(key) {
        return [' ', 'Enter'].includes(key);
    }

    disabled(disabled) {
        if (disabled != null) {
            this.$el[disabled ? 'addClass' : 'removeClass']('disabled');
            if (disabled)
                this.$el.removeAttr('tabindex');
            else
                this.$el.attr('tabindex', 0);
            this._disabled = disabled;
        }
        return this._disabled;
    }

    focus() {
        this.$el.focus();
    }
}



// WEBPACK FOOTER //
// ./makosh/assets/components/button.js